<template>
    <v-app>
        <div id="container">
            <v-img
                    alt="GameEnable"
                    class="shrink mr-2"
                    contain
                    src="../../assets/logo/one-line-dark.svg"
                    transition="scale-transition"
                    width="180"
                    style="position:absolute;left:0;    margin: 17px 17px 17px 20px;"
            />
            <div style="position: absolute; top: 90px; width: 100%; text-align: left; max-width: 90%; left: 0; right: 0; margin: auto;">

                <h4 style="font-size:24px;color:#fff;"> GameEnable DNS is blocked! </h4>


            </div>

            <div style="margin-top: 215px; margin-bottom: 30px; position: absolute; width: 100%; text-align: left; max-width: 90%; left: 0; right: 0; margin: auto; top: 150px;" class="">

                <v-stepper
                        style="max-width:500px;position:relative;"
                        v-model="step"
                        dark
                        color="pink"
                        vertical
                >
                     <div style="color: #fff; font-weight: 700; padding: 24px; padding-top: 30px; ">
                    Why are you seeing it and how can you fix it?
                </div>
                    <v-stepper-step
                            :complete="false"
                            step="1"
                            color="pink"
                    >
                       <span style="color:#fff"> The network you are accessing from is not whitelisted?</span>
                    </v-stepper-step>

                    <v-stepper-content step="4">
                        <v-card
                                color="transparent pt-4 elevation-0"
                                class="mb-12"

                        >
                            <ul style="color:#cecece;">
                                <li>Go to <a target="_blank" href="https://gameenable.com/account">GameEnable account page</a> </li>
                                <li>Look for the DNS block and click "Configure" And follow the instructions</li>
                            </ul>


                        </v-card>

                    </v-stepper-content>
                    <v-stepper-step
                            :complete="false"
                            step="2"
                            color="pink"
                    >
                        <span style="color:#fff">  You don't have a subscription? </span>
                    </v-stepper-step>

                    <v-stepper-content step="4">
                        <v-card
                                color="transparent pt-4 elevation-0"
                                class="mb-12"

                        >
                            <ul style="color:#cecece;">
                                <li>Go to <a target="_blank" href="https://gameenable.com/account">GameEnable account page</a> </li>
                                <li>Make sure you have an active subscription.</li>
                            </ul>


                        </v-card>

                    </v-stepper-content>
                    <v-stepper-content step="4">

                    </v-stepper-content>
                </v-stepper>
            </div>

        </div>
    </v-app>
</template>

<style>

    #container {
        max-height: 100vh;
        overflow: auto;
    }

    .container {


        height:100%;
        display:flex;
        justify-content:center;
        align-items:center;

    }

    .product-description{
        margin: 1px!important;
    }

    .dark-theme .payment-button-container {
        bottom: 39px !important;
        margin: 0;
        width: 100%!important;
        position: relative;
    }

</style>

<script>
    // @ is an alias to /src

    import {mapState} from 'vuex'


	export default {
        name: 'DNS_Setup_VPN',
        components: {

		},
        computed: {
            ...mapState(['user', 'signedIn', 'signInToken', 'initialized'])
        },

        data: () => ({
            step:4,
            paymentFormOpen: false,
            vpnConnectedSnackbar: false,
            connectingToVPN: false,
            notControllableDialog: false
        }),
        watch:{

        },
        methods: {

        }
    }
</script>
